import React from "react";
import { InputCostEstimationDialogInitialState, PageNewState } from ".";

export const InputCostEstimationDialogContext = React.createContext({
  pageState: InputCostEstimationDialogInitialState,
  setPageState: (pageState: PageNewState) => {},
});
